import { useSelector } from 'react-redux';

import { selectFleet } from '../selectors/stateSelectors';
import { timezonesEnum } from '../utils/timezones';

export const useTimezone = (fleetTimezone?: string): string => {
  const fleetFromStore = useSelector(selectFleet);

  return fleetTimezone || fleetFromStore?.timezone || timezonesEnum.AMERICA_NEW_YORK;
};
